function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: ",
        ";\n  }\n  to {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { keyframes } from "@emotion/react";
function buildStyle(param, param1) {
    var backgroundColor = param.backgroundColor, depth = param.depth, readingDirection = param1.readingDirection;
    var overlayAnimationIn = keyframes(_templateObject(), depth.opacity.heavy);
    var overlayAnimationOut = keyframes(_templateObject1(), depth.opacity.heavy);
    return {
        container: {
            width: '100%',
            position: 'relative'
        },
        base: _objectSpread({}, readingDirection, {
            width: '100%',
            height: 56,
            display: 'flex',
            background: backgroundColor.base,
            alignItems: 'center',
            justifyContent: 'space-between'
        }),
        border: {
            height: 4,
            width: '100%',
            background: "linear-gradient(\n          90deg,\n          ".concat(backgroundColor.brand.fill.base, " 0%,\n          ").concat(backgroundColor.accent.fill.base, " 95%\n        );")
        },
        overlay: {
            base: {
                background: backgroundColor.base,
                opacity: depth.opacity.heavy,
                width: '100%',
                height: 56,
                position: 'absolute',
                top: 0,
                left: 0,
                animation: "".concat(overlayAnimationIn, " 200ms cubic-bezier(0.2, 0, 0.4, 0.9)")
            },
            animationOut: {
                animation: "".concat(overlayAnimationOut, " 200ms cubic-bezier(0.2, 0, 0.4, 0.9)")
            },
            small: {
                opacity: 1
            }
        }
    };
}
export default function useStyle(param) {
    var isRtl = param.isRtl, breakpoints = param.breakpoints;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            containerStyles: {},
            wrapperStyles: {},
            borderStyles: {},
            overlayStyles: {}
        };
    }
    var base = builtStyle.base, border = builtStyle.border, overlay = builtStyle.overlay, container = builtStyle.container;
    return {
        containerStyles: container,
        wrapperStyles: base,
        borderStyles: border,
        overlayStyles: _objectSpread({}, overlay.base, _defineProperty({}, "@media (max-width: ".concat(breakpoints.m, "px)"), {
            opacity: 1
        }))
    };
};
